import React from 'react'
import clsx from 'clsx'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles'
import { Card, CardHeader, CardContent, CardActions, LinearProgress } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import M_ButtonSearch from 'components/1_Atoms/2_Molecules/M_ButtonSearch'
import A_Message from 'components/1_Atoms/A_Message'
import M_FieldTextLong from 'components/1_Atoms/2_Molecules/M_FieldTextLong'
import { useLogin } from 'hooks/useLogin'
import { useMediaQueryContext } from 'MediaQueryProvider'

const WIDTH = 500
const WIDTH_MIN = 320
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      alignContent: 'center',
      alignItems: 'center',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: `${theme.spacing(0)} auto`,
    },
    header: {
      textAlign: 'center',
      background: '#212121',
      color: '#fff',
    },
    card: {
      width: WIDTH,
      marginTop: theme.spacing(10),
    },
    cardM: {
      width: WIDTH_MIN,
      marginTop: theme.spacing(10),
    },
  }),
)

const O_SearchBoxLogin = ({ title }: { title: string }) => {
  const classes = useStyles()
  const { isMobileSite } = useMediaQueryContext()
  const [USER_CD, changeUserCode, PASSWORD, changePassword, login, loading, message, messageColor] = useLogin(useHistory())

  return (
    <form className={classes.container} noValidate autoComplete="none">
      <Card className={clsx(classes.card, isMobileSite && classes.cardM)} onSubmit={login}>
        <CardHeader className={classes.header} title={title} />
        {loading ? <LinearProgress /> : ''}
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <M_FieldTextLong
                key={1} //
                tab={1}
                label="ID"
                max={90}
                valueCode={USER_CD}
                change={changeUserCode}
                focus={true}
              />
            </Grid>
            <Grid item xs={12}>
              <M_FieldTextLong
                key={2} //
                tab={2}
                label="パスワード"
                type="password"
                max={30}
                valueCode={PASSWORD}
                change={changePassword}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Grid container className={classes.root} justifyContent={'center'}>
            <Grid item xs={8}>
              <A_Message color={messageColor} message={message} align={'center'} />
            </Grid>
            <Grid item xs={8}>
              <M_ButtonSearch label="ログイン" onClick={login} />
              <p style={{ textAlign: 'center' }}>
                <Link to={loading ? '' : '/createPassword'}>パスワード再発行はこちら</Link>
              </p>
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    </form>
  )
}
export default React.memo(O_SearchBoxLogin)
